import { Paper, TextField, Typography } from "@mui/material";

const sectionHeaderSx = {
	color: "primary.main",
	fontWeight: 600,
	fontSize: "0.85rem",
	textTransform: "uppercase" as const,
	letterSpacing: 0.4,
};

interface Props {
	title: string;
	value: string;
	disabled: boolean;
	onChange: (value: string) => void;
	onBlur: () => void;
}

export const CommentBox = ({
	title,
	value,
	disabled,
	onChange,
	onBlur,
}: Props) => (
	<Paper elevation={3} sx={{ p: 1.5, height: "100%" }}>
		<Typography sx={{ ...sectionHeaderSx, mb: 0.5 }}>{title}</Typography>
		<TextField
			fullWidth
			multiline
			minRows={3}
			size="small"
			placeholder="Add comments..."
			value={value}
			disabled={disabled}
			onChange={(e) => onChange(e.target.value)}
			onBlur={onBlur}
		/>
	</Paper>
);
